/* Naïa — Build-Your-Own bundle guard.
   Prevents adding an "infinite options" bundle (Build Your Own 2/5-pack) to cart
   until every scent select has a real value. Fixes empty "<>" bundle orders. */
(function(){
  'use strict';
  function getSelects(){ return Array.prototype.slice.call(document.querySelectorAll('select[name^="properties[Scent"]')); }
  function isChosen(s){ return s.selectedIndex > 0 && s.value && !/please select/i.test(s.value); }
  function allChosen(){ var s = getSelects(); return s.length > 0 && s.every(isChosen); }
  function getForm(){ return document.querySelector('.naia-form'); }
  function update(){
    var f = getForm(); if(!f) return;
    var ok = allChosen();
    Array.prototype.slice.call(f.querySelectorAll('.btn-cart, button[name="add"]')).forEach(function(b){ b.disabled = !ok; });
  }
  function run(){
    var f = getForm(); if(!f || !getSelects().length) return;
    if(!f.__naiaBundleGuard){
      f.__naiaBundleGuard = true;
      document.addEventListener('change', function(e){
        if(e.target && e.target.matches && e.target.matches('select[name^="properties[Scent"]')) update();
      }, true);
      f.addEventListener('submit', function(e){
        if(!allChosen()){ e.preventDefault(); e.stopImmediatePropagation(); update(); }
      }, true);
    }
    update();
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', run); } else { run(); }
  var n = 0, iv = setInterval(function(){ run(); if(++n > 12) clearInterval(iv); }, 500);
})();
